import { render, staticRenderFns } from "./FeaturedItems5.vue?vue&type=template&id=52a6ce4c"
import script from "./FeaturedItems5.vue?vue&type=script&lang=js"
export * from "./FeaturedItems5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports